
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'qs';
import { getValidToken} from "src/auth/auth";

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: "https://alpha.management.bluey.device.finance.amazon.dev",
        prepareHeaders: async (headers) => {
            headers.set('Content-Type', 'application/json');
            const token = await getValidToken();
            headers.set('Authorization',`Bearer ${token}`);
            return headers;
        },
        paramsSerializer: (params)=>{
            return qs.stringify(params, { arrayFormat: 'repeat' });
        }
    }),
    keepUnusedDataFor: 30,
    endpoints: () => ({}),
    tagTypes:["tools", "TestSuite", "UAT"],
    refetchOnFocus: false,
    refetchOnReconnect: false,
    refetchOnMountOrArgChange: false
});
